module.exports = "/assets/sharky.png";